import React, { useState, useMemo } from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import FilterCard from "./components/filterCard";
import HistoryCard from "./components/historyCard";
import RouteReplayMap from "./components/routeReplayMap";
import SpeedAnalysis from "./components/speedAnalysis";
import { IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import left from "../../assets/images/left.png";
import right from "../../assets/images/right.png";

function RouteReplay() {
  const [collapsed, setCollapsed] = useState(false);
  const [isTripDrawerOpen, setIsTripDrawerOpen] = useState(false);
  const devices = useSelector((state) => state.routeReplay.devices);

  const sidebarWidth = 430;

  const devicePackets = useMemo(() => {
    if (!devices || !devices.devices) return [];
    return Object.entries(devices.devices)
      .filter(([key]) => !isNaN(key))
      .map(([timestamp, data]) => ({ timestamp: Number(timestamp), ...data }))
      .sort((a, b) => a.timestamp - b.timestamp);
  }, [devices]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        sx={{
          display: "flex",
          height: "calc(100vh - 75px)",
          overflow: "hidden",
          position: "relative",
          p: 1,
        }}
      >
        {/* SIDEBAR SECTION */}
        <MDBox
          sx={{
            position: "absolute",
            top: 10,
            left: collapsed ? `-${sidebarWidth + 20}px` : 10,
            borderRadius: "24px",
            width: `${sidebarWidth}px`,
            height: "calc(100% - 20px)",
            background: "white",
            boxShadow: "2px 0 6px rgba(0,0,0,0.1)",
            zIndex: 12,
            overflowY: "auto", // Scrolling enabled rahegi
            transition: "left 0.3s ease-in-out",

            /* Scrollbar chhupane ke liye niche wala code: */
            "&::-webkit-scrollbar": {
              display: "none", // Chrome, Safari aur naye Edge ke liye
            },
            msOverflowStyle: "none", // Internet Explorer aur puraane Edge ke liye
            scrollbarWidth: "none", // Firefox ke liye
          }}
        >
          <FilterCard onClearTable={() => {
            setIsTripDrawerOpen(false);
            // dispatch(setHighlightSegment(null));
          }} />
          {devicePackets.length > 0 && (
            <MDBox>
              <HistoryCard />
              {/* Note: SpeedAnalysis is also rendered here to show buttons/chart */}
              <SpeedAnalysis
                onDrawerStateChange={setIsTripDrawerOpen}
                isInsideSidebar={true}
              />
            </MDBox>
          )}
        </MDBox>

        {/* COLLAPSE BUTTON */}
        <IconButton
          onClick={() => setCollapsed(!collapsed)}
          sx={{
            position: "absolute",
            top: "20px",
            left: collapsed ? "20px" : `${sidebarWidth + 20}px`,
            zIndex: 15,
            backgroundColor: "white !important",
            boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            transition: "left 0.3s ease-in-out",
          }}
        >
          {collapsed ? <img src={right} width="24px" /> : <img src={left} width="24px" />}
        </IconButton>

        {/* MAIN CONTENT AREA (MAP + TABLE) */}
        <MDBox
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            marginLeft: collapsed ? "0px" : `${sidebarWidth + 20}px`,
            height: "100%",
            transition: "margin-left 0.3s ease-in-out",
            gap: 1.5
          }}
        >
          {/* MAP SECTION */}
          <MDBox
            sx={{
              flex: isTripDrawerOpen ? "0 0 50%" : "1",
              borderRadius: "24px",
              overflow: "hidden",
              transition: "flex 0.4s ease-in-out",
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)"
            }}
          >
            <RouteReplayMap />
          </MDBox>

          {/* ANALYSIS TABLE SECTION (Only visible when open) */}
          {isTripDrawerOpen && (
            <SpeedAnalysis
              onDrawerStateChange={setIsTripDrawerOpen}
              isInsideSidebar={false}
            />
          )}
        </MDBox>
      </MDBox>
    </DashboardLayout>
  );
}

export default RouteReplay;